module.exports = __webpack_public_path__ + "img/Banner3.f0ca692b.jpg";